import { Injectable } from "@angular/core";
import { DocumentService } from "../../../../services/documentService";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { ActivatedRouteSnapshot } from "@angular/router";
import { CBP7501 } from "../../../../objects/documents/CBP7501";

@Injectable()
export class OrderDataCBP7501Resolver {

    constructor(private documentService: DocumentService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<BaseResponse<Array<CBP7501>>> {
        let orderId = route.params["id"];

        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];

        if (!orderId)
            return null;

        return this.documentService.getDocuments<CBP7501>(orderId, 'CBP7501', 0, 100);
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/orderDataCBP7501.resolver.ts